module.exports = __webpack_public_path__ + "img/200.problem_broken_door_lock.d66604ef.svg";